import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 控制台 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageMain = _resolveComponent("PageMain")!

  return (_openBlock(), _createBlock(_component_PageMain, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}